import React from 'react';

const ROWS = [
  { op: 'Cancel (supplier)', tripjack: 'in_app', riya: 'in_app', offline: 'in_app' },
  { op: 'Hold confirm / release', tripjack: 'in_app', riya: 'in_app', offline: '—' },
  { op: 'Reschedule', tripjack: 'manual_portal', riya: 'in_app', offline: 'manual_portal' },
  { op: 'Post-book SSR', tripjack: 'manual_portal', riya: 'in_app', offline: '—' },
  { op: 'Void / reissue / split PNR', tripjack: 'manual_portal', riya: 'manual_portal', offline: 'manual_portal' },
  { op: 'Name change', tripjack: 'manual_portal', riya: 'manual_portal', offline: 'manual_portal' },
];

const chip = (ch) => {
  const inApp = ch === 'in_app';
  return (
    <span className={`text-[10px] px-1.5 py-0.5 rounded font-semibold ${inApp ? 'bg-emerald-100 text-emerald-800' : ch === '—' ? 'bg-gray-100 text-gray-400' : 'bg-amber-100 text-amber-900'}`}>
      {inApp ? 'API' : ch === '—' ? '—' : 'Portal'}
    </span>
  );
};

export default function AmendmentModeMatrix() {
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 overflow-x-auto" data-testid="amendment-mode-matrix">
      <p className="text-[10px] uppercase font-bold text-gray-500 mb-2">Amendment channels</p>
      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-gray-500">
            <th className="pb-1 pr-2">Operation</th>
            <th className="pb-1 pr-2">Tripjack</th>
            <th className="pb-1 pr-2">Riya</th>
            <th className="pb-1">Offline</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r) => (
            <tr key={r.op} className="border-t border-slate-200/80">
              <td className="py-1 pr-2 font-medium text-gray-800">{r.op}</td>
              <td className="py-1 pr-2">{chip(r.tripjack)}</td>
              <td className="py-1 pr-2">{chip(r.riya)}</td>
              <td className="py-1">{chip(r.offline)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
